import { Box, FormControl, Grid, TextField } from '@mui/material';
import { IReportField } from 'src/types/reportField';

const TextBoxFilterField = ({ reportField, onChange }: { reportField: IReportField; onChange }) => (
  <Grid size={{ xs: 12 }}>
    <FormControl sx={{ mb: 3, width: '100%' }}>
      <Box sx={{ mb: 1 }}>
        <label>{reportField?.caption}:</label>
      </Box>
      <TextField type="text" variant="outlined" defaultValue={reportField?.fieldValue} onChange={onChange} />
    </FormControl>
  </Grid>
);

export default TextBoxFilterField;
